import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";
import { FloatCategories } from "components/special/contents";

export const CategoriesWithScore = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <div className="row">
                <div className="col-6">
                  <div className="form-group row">
                    <label className="col-6 col-form-label">
                      {intl.formatMessage({ id: "OpenAI.Schedules.category" })}
                    </label>
                    <div className="col-6">
                      <FloatCategories
                        _id={elem.categoryId}
                        // query={{ countryId: undefined }}
                        multi={false}
                        showTitle={true}
                        showCount={false}
                        className="btn-sm"
                        successHandler={([categoryId]) => {
                          Object.assign(values[index], { categoryId });
                          changeValues(values);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    name="minScore"
                    className="form-control"
                    placeholder={intl.formatMessage({
                      id: "OpenAI.Schedules.minScore",
                    })}
                    value={elem.minScore || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col text-right">
              <CategoriesWithScore.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

CategoriesWithScore.AddButton = (props) => {
  const { values = [], changeValues } = props;
  // const addValue = () => {
  //   changeValues(values.concat([{}]));
  // };
  const valuesId = _.map(values, (value) => value.categoryId);
  const addValues = (categoriesId = []) => {
    changeValues(
      values.concat(
        ...categoriesId
          .filter((categoryId) => !valuesId.includes(categoryId))
          .map((categoryId) => ({ categoryId }))
      )
    );
  };

  return (
    <FloatCategories
      _id={valuesId}
      multi={true}
      showTitle={false}
      showCount={false}
      query={{ countryId: null }}
      icon="fa-plus"
      className={`btn-sm btn-success ${props.className}`}
      successHandler={addValues}
    />

    /*
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
    */
  );
};

CategoriesWithScore.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default CategoriesWithScore;
